export default __webpack_public_path__ + "static/media/Padron_50Closed.f6f17f47.jpg";